// API Endpoints constants

export const fundManagementApiUrls = {
    viewAllFundDetailsUrl: 'fund/mm-funds',
    viewAllTransactionDetailsUrl: 'transaction/mm-transaction',
    getDailyFundPrice: 'fund/daily-fund-price',
    getUnitAllocationInfoByOrderId: 'transaction/mm-transaction/unit-allocation'
}

export const ordersApiUrls = {
    getAllUserWiseContributionUrl: 'order/user-contribution',
    getAllUserPlanWiseContributionUrl: 'order/plan-contribution',
    getAllTodayOrderListUrl: 'order/today-order',
    getAllTodayOrderListUsersDetailed: 'order/today-order/detailed',
    getTotalContributtedAmount: 'order/total-contributted-amount',
    getAllOrderListUrl: 'order/mm-order',
    createAndPlaceOrderUrl: 'order/mm-order/create',
    getAllPlansUrl: 'order/get-plans',
    getAllPensionPlans: 'master/all-pension-plans',
    getAllFundsUrl: 'order/get-funds',
    getIbOrderById: 'order/mm-order/',
    getIBOrderStatusUrl: 'order/iborder-status/',
    confirmIBOrderReplyUrl: 'order/iborder-reply/',
    getAllMMUnitSaleList: 'order/mm-units-sales',
    getEmployeeDetailsByEmailOrUniqueIdUrl: 'order/employee-details',
    transferOutUserUnits: 'order/units/transfer-out',
    getAllUsersOrderByDetail: 'order/users-order-detailed',
    getAllUsersOrderTotalByDetail: 'order/users-order-total-detailed',
    exportOrdersInDetails: 'order/export-users-order',
    exportOrderHistory: 'order/mm-order/export-history',
    exportOrderReport: 'order/export-order-report',
    getMasterFundsList: 'master/all-fund-details',
    zpUserBuyValue: 'order/zp-user-buy-value/create',
    updateUnitReallocation: 'order/units-reallocation/update-user-units',
    getAllReallocationData: 'order/units-reallocation/get-all-reallocation-data',
    exportAllReallocationData: 'order/units-reallocation/export-all-reallocation-data',
}

export const userSalesUnitUrls = {
    createSalesUnits: 'add-user-sales-unit',
    getAllUserSaleUints: 'all-user-sales-unit',
    getAllDetailedUserSaleUnits: 'all-user-sales-unit/detailed'
}

export const customerAPiUrls = {
    getAllEmails: 'all-customer-emails',
    customerRetire: 'customer-retire/',
    customerPayment: 'customer-payment/',
    customerTotalPot: 'customer-total-pot',
    getAllCustomers: 'customer',
    updateCustomerService: 'update-customer/',
    exportMonthWiseHoldings: 'customer/export-month-wise-holdings',
    customerOnBoardRequest: 'on-board-request',
    customerAcceptOnboardRequest: 'accept-onboard-request',
    customerRejectOnboardRequest: 'reject-onboard-request',
    customerAcceptAvcRequest: 'accept-avc-request',
    customerRejectAvcRequest: 'reject-avc-request',
}


export const auditApiUrls = {
    auditUser: 'audit-user',
    auditEmployee: 'audit-employee',
    auditComplaint: 'audit-complaint',
    auditChat: 'audit-chat',
    auditTransaction: 'audit-transaction',
    auditExport: 'audit-export/',
}


export const contributionUrls = {
    contributionUpload: 'contribution-upload/'
}


export const feeCalculationUrls = {
    dailyFundFee: 'daily-funds-fee',
    monthlyFundFee: 'monthly-funds-fee',
    searchDailyFeeTable: 'search-daily-fee',
    fetchFundLevelFees: 'get-daily-funds-fee',
    fetchMonthlyUnits: 'get-monthly-fund-units'

}

export const reportUrls = {
    getAllBankFileRecordReport: 'report/bank-file-record-report',
    exportBankFileRecordReport: 'report/export-bank-file-record-report',
    exportPepReport: 'report/export-pep-report',
    exportFeeReport: 'report/export-fee-details'

}


export const requestUrls = {
    employeePlanReqView: "employee-plan-req-view/",
    employeePlanReqUpdate: "employee-plan-req-update/",
    employeeWithdrawalView: "employee-withdrawal-view/",
    employeeWithdrawal: "employee-withdrawal/",
    employeeWithdrawalUpdate: "employee-withdrawal-update/",
    employeeTransferAdd: 'employee-transfer-add/',
    employeeTransferView: 'employee-transfer-view/',
    employeeTransfer: 'employee-transfer/',
    stockPrice: 'stock-price/'
}





export const userServiceApiUrls = {
    registerUrl: "employee-register",
    registerOrgEmployeeUrl: "org-employee-register",
    uploadFileUrl: "employee-upload",
    uploadFileDataValidationUrl: "employee-upload-validation",
    uploadFileDataBulkCreateUrl: "employee-upload-bulk-create",
    uploadFileDataBulkEmailCreateUrl: "employee-upload-bulk-email-create",
    getAllUsersUrl: "employee",
    getAllOrganizationAdminsUrl: "organization-employee-role",
    getAllOrganizationEmployeeWithRoleNameUrl: "employee-list",
    getAllOrganizationEmployeeDetailsUrl: "organization-employee-details",
    updateEmployeeUrl: "employee-update",
    onboardNotifyEmployeeUrl: "employee-obboard-notify",
    removeEmployeeUrl: "employee-delete",
    removeAdminEmployeeUrl: "admin-employee-delete",
    removeOrganizationEmployeeUrl: "organization-employee-delete",
    emailAlreadyExistsUrl: "auth/emailAlreadyExists",
    getUserTokenByIdUrl: "admin/auth/employee-token",
    getUserByIdUrl: "employee-show",
    displayEmployeeInfoUrl: "employee-info",
    updateOrganizationEmployeeUrl: "organization-employee-update",
    resendInviteLinkToOrgEmployeeUrl: "organization-employee-invite",
    getEmployeeDetailsByUserIdUrl: "employee-details",
    getUserPensionUrl: "employee-pension",
    getUserPaymentsUrl: "employee-payments",
    getUserTransactionsUrl: "employee-transations",
    getAllUserTransactionsUrl: "employee-transactions-all",
    getZpUserTransactionsUrl: "zp-user-transations",
    orgAdminEmployeeInvite: 'organization-admin-employee-invite/',
    orgRegEmployee: 'org-reg-employee',
    getUserPlanUrl: 'user-plan',
    reRegisterOrganizationEmployeeUrl: 'organization-employee-reregister',
    getUserByEmailOrUniqueId: 'user-email',
    getResource: 'auth/resource',
}

export const chatApiUrls = {
    createChatConversationUrl: 'create-conversation',
    getAllConversationUrl: 'conversation',
    getConversationByIdUrl: 'conversation-user',
    getConversationByConverIdUrl: 'conversation',
    readChatConversationUrl: 'read-conversation',
    updateConversationStatusUrl: 'update-status',
    getAllChatByConversationIdUrl: 'all-messages',
    getAllChatByComplaintIdUrl: 'all-complaint-messages',
    createChatMessagesUrl: 'create-messages',
    createComplaintMessagesUrl: 'create-complaint-messages',
    uploadChatImageUrl: 'upload/chat-image',
    displayNotificationsByChatTypeUrl: 'view-notifications',
    getEmailListServiceUrl: 'conversation-email-list',
    createGroupChatConversationUrl: 'create-group-conversation',
    getOrgCompanyListServiceUrl: 'conversation-org-company-list',
}

export const operationalTeamApiUrls = {
    getAllSupportEmployeeListUrl: 'mm-support-employee/list',
    createComplatintForSupportUrl: 'mm-support-employee/create'
}

export const requestApiUrls = {
    viewAllPlanChangeRequestsUrl: 'employee-plan-req-view',
    updatePlanChangeRequestStatusUrl: 'employee-plan-req-update',
    viewAllWithdrawalRequestsUrl: 'employee-withdrawal-view',
    viewWithdrawalRequestByIdUrl: 'employee-withdrawal',
    updateWithdrawalRequestUrl: 'employee-withdrawal-update',
    addNewTransferRequestUrl: 'employee-transfer-add',
    updateTransferRequestUrl: 'employee-transfer-update',
    viewTransferRequestsUrl: 'employee-transfer-view',
    viewTransferOutRequestsUrl: 'employee-transfer-out-view',
    viewTransferRequestByUserIdUrl: 'employee-transfer',
    marketDataPriceByConidUrl: 'stock-price',
    getAllUserPlanRequestsUrl: 'user-plan-req-view',
    getAllUserWithdrawalRequestsUrl: 'user-withdrawal-view'
}

export const uploadBankFileApiUrls = {
    createBankFiles: 'transaction/bank-file',
    getBankFiles: 'transaction/bank-file',
    downloadBankFiles: 'transaction/bank-file/download',
    createFileUploadForCustomer: "transaction/customer-bank-file",
    getOrganizationsListUrl: "employer-list",
    getBankFilesById: 'transaction/bank-file-record',
    updateBankRecordFileStatus: 'transaction/bank-file-record/status',
    getBankFilesByStatus: 'transaction/bank-file-record',
    updateBankFileManualReconcile: 'transaction/bank-file-record/manual',
    getManualBankRecordFileByBankRecordFileId: 'transaction/manual-bank-file-record',
    getBankTransactionFile: 'transaction/export-bank-file'

}
export const contributionApiUrls = {
    getTotalContributionOfOrganizationUrl: "contribution",
    removeContributionEmployeeEntryUrl: "contribution-remove-employee-entry",
    uploadAgainEmployeeContributionUrl: "contribution-upload-again",
    getOrganizationContributionFilesUrl: "contribution-files",
    exportOrganizationContributionFilesUrl: "contribution-files-export",
    getContributionFileUrl: "download-contribution-file",
    deleteContributionFileUrl: "delete-contribution-file",
    getContributionHoldings: "contribution/holding",
    getOrganizationContribution: "organization-contribution",
    getEmployeeContribution: "employee-contribution-details",
    getContributionFileDetailsUrl: "contribution-file-details",
    getMonthWiseContributionHoldings: "contribution/month-wise-holdings",
    getUserContribution: "user-contribution",
}


export const chartServiceUrls = {
    userChart: "chart/user-data",
    contributionChart: 'chart/contribution-data',
    orgUserChart: 'chart/org-user-data',
}

export const configurationServiceUrls = {
    getConfig: "system-configuration",
    updateConfig: "update-system-configuration",
}

export const complaintsServiceUrls = {
    getAllComplaints: "all-complaints",
    getComplaintByComplaintId: 'customercomplaints/',
    getComplaintByUserId: "complaints/",
    exportComplaints: 'export-complaints'
}

export const employerServiceUrls = {
    getAllEmployers: "employer"
}

export const economicStatus = {
    employmentCategory: 'master/employment-category',
}